module.exports = __webpack_public_path__ + "media/assets/images/flags/to-e4b1329d51d20c075b29d3674f7746c0.svg";